import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import isString from "lodash/isString";

const operationDepartmentApi = AiseaApiFactory.get("operationDepartment");

class OperationDepartmentService {
  /**
   * 部署名の一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {string[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  async getOperationDepartmentNames() {
    return await operationDepartmentApi.getOperationDepartmentNames();
  }

  isOperationDepartmentName(obj) {
    return isString(obj) && obj.trim().length > 0;
  }
}

export default new OperationDepartmentService();
